export class ApiEndPointsUser {

  // Summary
  // Call api to get user list
  userList = 'api/ManageUser/GetUserList';

  // Summary
  // Call api to register user
  registerUser = 'api/ManageUser/RegisterUser';

  // Summary
  // Call api to get user detail
  getUserDetail = 'api/ManageUser/GetUserDetail';
  // Summary
  // Call api to register user
  updateUser = 'api/ManageUser/UpdateUser';

  // Summary
  // Call api to delete user
  deleteUser = 'api/ManageUser/DeleteUser';

  // Summary
  // Call api to check existing user
  checkExistingUser = 'api/ManageUser/CheckExistingUser';

  // Summary
  // Call api to resetPassword
  resetPassword = 'api/ManageUser/ResetPassword';

  // Summary
  // Call api to send mail
  forgotPasswordCheckUser = 'api/ManageUser/GetForgotPasswordLink';

  
  // Summary
  // Call api to update password
  updatePassword = 'api/ManageUser/ForgotPassword';
  getLoggedInUserDetailsManageUser = 'api/ManageUser/GetUserProfileDetail';
  updateUserProfile = 'api/ManageUser/UpdateUserProfile';
  getImageUploadURL ='api/App/UploadProfilePic';
  changePassword = "api/Auth/ChangePassword";
  setMFA = "api/ManageUser/SetMFA";
  addUserService = "api/ManageUser/AddUserService";
  AddUpdateUserNotificationPreferances = "api/ManageUser/AddUpdateUserNotificationPreferances";
  getUserProfileServices="api/ThirdPartyApis/GetUserProfileServices";
  getSuperAdminThirdPartyApi="api/ThirdPartyApis/GetSuperAdminThirdPartyApi";
   getAllTrainingContent = "api/Training/GetAllTrainingContent";
}
